import { FC, ReactNode, useContext, MouseEvent, useState } from 'react'
import { Container, Row, Col, Nav } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'

import { simMod, moduleContent } from '../Module.config'
import { ModuleContext } from '../contexts/ModuleContext'
import { concedeControl } from '../LMS'
import { preventContextMenu, addBodyClass } from '../Utils'

import { Section, ModuleNavItem } from '../Types'
import { ModuleClass } from '../ModuleTypes'
import SimutechLogo from '../assets/images/Logo.png'
import HelpMenu from './HelpMenu'
import LRSPath from './LRSPath'

import { ReactComponent as HelpIcon } from '../assets/icons/help.svg'
import { ReactComponent as ExitIcon } from '../assets/icons/exit.svg'

import './Home.scss'
import { IconButton } from '../styles/Buttons'
import { useLMSContext } from '../contexts/LMSContext'

const { type, navItems, company } = simMod

const getSections = (): ReactNode[] => {
    const sections = moduleContent.sections

    if (type === ModuleClass.TS || !sections.length)
        return navItems.map((link: ModuleNavItem, idx: number) => <LRSPath key={`tsl${idx}`} label={link.name} path={link.path} sectionID={0} />)

    return sections.map((section: Section) => (
        <LRSPath
            key={`lll${section.id}`}
            label={section.name}
            path={`./learn/${section.id}`}
            sectionID={section.id}
        />
    ))
}

const Home: FC = () => {
    const context = useContext(ModuleContext)
    const { lmsState: { isLMSAvailable } } = useLMSContext()
    context.faultID = 'F000'
    addBodyClass(type)

    const [showHelpMenu, setShowHelpMenu] = useState(false)
    const hideHelpMenu = () => setShowHelpMenu(false)

    const handleHelpClick = (e: MouseEvent) => {
        e.preventDefault()
        setShowHelpMenu(true)
    }

    const desc = ReactHtmlParser(moduleContent.description)
    const routes = getSections()

    return (
        <>
            <Container
                onContextMenu={(e: MouseEvent) => preventContextMenu(e)}
                className="min-specs module-content"
                fluid={true}
            >
                <Row>
                    <Col>
                        <div className="logo">
                            <img src={SimutechLogo} alt={company} />
                        </div>
                    </Col>
                    <Col>
                        <Nav className="top-nav justify-content-end flex-nowrap">
                            <Nav.Link>
                                <IconButton
                                    title={'Help'}
                                    onClick={handleHelpClick}
                                >
                                    <HelpIcon />
                                </IconButton>
                            </Nav.Link>
                            <HelpMenu
                                visible={showHelpMenu}
                                hideMenu={hideHelpMenu}
                            />
                            <Nav.Link className="exit-btn" hidden={!isLMSAvailable}>
                                <IconButton onClick={concedeControl}>
                                    <ExitIcon />
                                </IconButton>
                            </Nav.Link>
                        </Nav>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{ offset: 1 }}>
                        <div className="title">{moduleContent.title}</div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{ span: 5, offset: 1 }}>
                        <section className="description">
                            {desc}
                            <p>{`Click on a section to continue.`}</p>
                        </section>
                    </Col>
                    <Col sm={{ span: 5, offset: 1 }}>
                        <Nav className="justify-content-end flex-column right-nav">
                            {routes}
                        </Nav>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Home
